export default (id, data) => {
    try {
      localStorage.setItem(id, JSON.stringify(data));
    } catch (e) {
      console.log("LocalStorage not supported!");
    }
};
